import { render, staticRenderFns } from "./usahaKeuangan.vue?vue&type=template&id=0f9556c4&"
import script from "./usahaKeuangan.vue?vue&type=script&lang=js&"
export * from "./usahaKeuangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QBtn,QBadge,QDialog,QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QBtn,QBadge,QDialog,QCard,QCardSection,QCardActions})
